import SettingSection from 'flow/components/Setting/SettingSection';
import Divider from 'flow/components/ui-components/Divider';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';
import { BusyNoAnswerValues } from '../CreateProfileModal';

interface Props {
    selected: BusyNoAnswerValues;
    onChange: (newValue: BusyNoAnswerValues) => void;
}

const ConnectCallsToSection = ({ selected, onChange }: Props) => {
    const { i18next } = useAppContext();

    return (
        <>
            <Divider />

            <SettingSection>
                {i18next.t('settings.profile.wizard.busynoanswer')}
            </SettingSection>

            <RadioButton
                name="busyNoAnswer"
                checked={selected === 'voicemail'}
                onChange={() => onChange('voicemail')}
            >
                {i18next.t('settings.incoming_calls.profile.referal.voicemail')}
            </RadioButton>

            <RadioButton
                name="busyNoAnswer"
                checked={selected === 'busy'}
                onChange={() => onChange('busy')}
            >
                {i18next.t('settings.profile.wizard.busynoanswer.ringbusy')}
            </RadioButton>
        </>
    );
};

export default ConnectCallsToSection;
